<script>
import { fabric } from 'fabric';
import ImageBoxTool from './ImageBoxTool';

export default {
  name: 'CropImageBoxTool',
  extends: ImageBoxTool,
  data() {
    const el = new fabric.Rect({
      // left: 100,
      // top: 100,
      fill: 'transparent',
      originX: 'left',
      originY: 'top',
      stroke: '#ccc',
      strokeDashArray: [2, 2],
      opacity: 1,
      width: 1,
      height: 1,
    });
    const pos = [212, 23];
    // pos[0] = r.left;
    // pos[1] = r.top;
    return {
      icon: 'crop',
      title: 'Crop',
      showLocal: false,
      crop_active: false,
      mousex: 0,
      mousey: 0,
      crop: false,
      el,
      pos,
      active: null,
      activated: false,
    };
  },
  computed: {
    show() {
      return this.showLocal;
    },
  },
  beforeDestroy() {
    this.canvas.remove(this.el);
  },
  mounted() {
    this.$nextTick().then(() => {
      const r = this.canvas.contextContainer.canvas.getBoundingClientRect();
      console.log(r);
      this.pos[0] = r.left;
      this.pos[1] = r.top;
      // this.mouse_listerners()
      this.el.visible = false;
      // var r    = this.canvas.getBoundingClientRect()
      // this.pos =
      this.canvas.add(this.el);
      this.canvas.setActiveObject(this.el);
    });

    this.$nextTick().then(() => {
      this.canvas.on({
        'selection:created': this.activate,
        'selection:updated': this.activate,
      });
    });
  },
  methods: {
    activate() {
      if (this.canvas && this.canvas.getActiveObject()) {
        this.showLocal = true;
      } else {
        this.showLocal = false;
      }
    },
    action() {
      if (this.active) {
        this.active.selectable = true;
        this.active.evented = true;
        this.active = null;
      } else {
        this.active = this.canvas.getActiveObject();
        this.active.selectable = false;
        this.active.evented = false;
        this.active.clipPath = null;
        this.deactivateObjects();
      }
      this.canvas.renderAll();
    },
    deactivateObjects() {
      this.canvas.getObjects().forEach((i) => {
        i.selectable = false;
        i.evented = false;
      });
    },
    activateObjects() {
      this.canvas.getObjects().forEach((i) => {
        i.selectable = true;
        i.evented = true;
      });
    },
    docrop() {
      let left = this.el.left - this.active.left;
      let top = this.el.top - this.active.top;

      const scale = this.active.scaleX;
      left *= 1 / scale;
      top *= 1 / scale;

      console.log(left, ' -- ', top, ' scale', scale);
      const width = (this.el.width * 1) / scale;
      const height = (this.el.height * 1) / scale;
      console.log((-scale * this.active.width) / (2.0), -(scale * this.active.height) / (2.0));
      console.log(-this.active.width / (2.0), -this.active.height / (2.0));

      const xc = this.active.width / 2.0;
      const yc = this.active.height / 2.0;
      this.active.clipPath = new fabric.Rect({
        left: left - xc, top: top - yc, width, height,
      });
      // disabled = true;
      this.el.visible = false;
      this.activateObjects();
      this.canvas.renderAll();
    },
    mouse_listerners() {
      this.canvas.on('mouse:down', (event) => {
        if (this.active == null) {
          return;
        }
        console.log(`START ${this.pos[0]} ${this.pos[1]}`);
        console.log(`EVENT ${event.e.pageX} ${event.e.pageY}`);
        console.log(`CL ${event.e.clientX} ${event.e.clientY}`);

        this.el.left = event.e.clientX - this.pos[0];
        this.el.top = event.e.clientY - this.pos[1];
        this.el.visible = true;
        this.mousex = event.e.pageX;
        this.mousey = event.e.pageY;
        this.crop = true;
        this.canvas.bringToFront(this.el);
      });
      this.canvas.on('mouse:move', (event) => {
        // console.log("MOVE")
        if (!this.crop) {
          return;
        }
        if (event.e.pageX - this.mousex > 0) {
          this.el.width = event.e.pageX - this.mousex;
        }

        if (event.e.pageY - this.mousey > 0) {
          this.el.height = event.e.pageY - this.mousey;
        }

        this.canvas.renderAll();
      });
      this.canvas.on('mouse:up', (event) => {
        if (!this.crop) {
          return;
        }
        this.crop = false;

        if (this.active) {
          this.docrop();
          this.active.selectable = true;
          this.active.evented = true;
          this.active = null;
        } else {
          console.log('FAIL');
        }
      });
    },
  },
};
</script>
